import { SET_LOADER } from './types';

export const saveloaderAction = bool => {
  return { type: SET_LOADER, payload: bool };
};